import React from 'react'
import { useAppSelector } from '../../shared/redux/hooks'
import { getNavConfig } from './navConfig'
import { NavItemComponent } from './NavItemComponent'
import UserInfo from './UserInfo'
import ThemeToggle from './ThemeToggle'

interface MenuProps {
  collapsed?: boolean
}

const Nav: React.FC<MenuProps> = ({ collapsed }) => {
  const { permissions } = useAppSelector((state) => state.app)

  const hasFileExplorerPermission = permissions?.includes('storagedrive:file:read') ?? false
  const hasEventHandlingReportPermission = permissions?.includes('read:event-report') ?? false
  const hasSaber = permissions?.includes('saber:read') ?? false
  const hasConductor = permissions?.includes('conductor:read') ?? false
  const navConfig = getNavConfig(hasFileExplorerPermission, hasEventHandlingReportPermission, hasSaber, hasConductor)

  return (
    <>
      <div className="flex flex-1 flex-col justify-between py-0 pb-2.5 overflow-y-auto">
        <div>
          {navConfig.map((item, index) => (
            <NavItemComponent key={`${item.to}-${index}`} item={item} collapsed={collapsed} />
          ))}
        </div>
        <ThemeToggle collapsed={collapsed} />
      </div>
      <UserInfo collapsed={collapsed} />
    </>
  )
}

export default Nav
